import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'irembogov-replace-comment-confirm-modal',
  templateUrl: './replace-comment-confirm-modal.component.html',
})
export class ReplaceCommentConfirmModalComponent {
  constructor(public modal: NgbActiveModal) {}
}
